import { useState, useEffect } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { supabase } from './lib/supabase'
import Login from './pages/Login'
import Layout from './components/Layout'
import Students from './pages/teacher/Students'
import Attendance from './pages/teacher/Attendance'
import Grades from './pages/teacher/Grades'
import Homework from './pages/teacher/Homework'
import Reports from './pages/teacher/Reports'
import ParentHome from './pages/parent/Home'
import ParentGrades from './pages/parent/Grades'
import ParentAttendance from './pages/parent/Attendance'
import ParentHomework from './pages/parent/Homework'
import ParentReports from './pages/parent/Reports'
import StudentHome from './pages/student/Home'
import StudentGrades from './pages/student/Grades'
import StudentAttendance from './pages/student/Attendance'
import StudentHomework from './pages/student/Homework'
import StudentReports from './pages/student/Reports'
import Settings from './pages/Settings'
import Videos from './pages/Videos'

export default function App() {
  const [session, setSession] = useState(null)
  const [role, setRole] = useState(null)
  const [loading, setLoading] = useState(true)
  const [theme, setTheme] = useState(() => localStorage.getItem('theme') || 'light')

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme)
    localStorage.setItem('theme', theme)
  }, [theme])

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session)
      if (session) checkRole(session.user.id)
      else setLoading(false)
    })
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_e, session) => {
      setSession(session)
      if (session) checkRole(session.user.id)
      else { setRole(null); setLoading(false) }
    })
    return () => subscription.unsubscribe()
  }, [])

  async function checkRole(userId) {
    setLoading(true)
    const { data: t } = await supabase.from('teachers').select('id, role').eq('id', userId).maybeSingle()
    if (t) { setRole(t.role === 'assistant' ? 'assistant' : 'teacher'); setLoading(false); return }
    const { data: p } = await supabase.from('parents').select('id').eq('id', userId).maybeSingle()
    if (p) { setRole('parent'); setLoading(false); return }
    const { data: s } = await supabase.from('student_accounts').select('id').eq('id', userId).maybeSingle()
    if (s) { setRole('student'); setLoading(false); return }
    setRole(null); setLoading(false)
  }

  if (loading) return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100vh', background:'var(--bg)' }}>
      <div style={{ width:32, height:32, border:'3px solid var(--border)', borderTopColor:'var(--accent)', borderRadius:'50%', animation:'spin 1s linear infinite' }} />
      <style>{`@keyframes spin { to { transform: rotate(360deg) } }`}</style>
    </div>
  )

  const staffRoutes = (
    <>
      <Route path="/" element={<Navigate to="/students" />} />
      <Route path="/students"   element={<Students />}   />
      <Route path="/attendance" element={<Attendance />} />
      <Route path="/grades"     element={<Grades />}     />
      <Route path="/homework"   element={<Homework />}   />
      <Route path="/reports"    element={<Reports />}    />
      <Route path="/videos"     element={<Videos role={role} />} />
      <Route path="/settings"   element={<Settings theme={theme} setTheme={setTheme} />} />
    </>
  )

  return (
    <BrowserRouter>
      <Routes>
        {!session ? (
          <Route path="*" element={<Login />} />
        ) : role === 'teacher' || role === 'assistant' ? (
          <Route element={<Layout role={role} theme={theme} setTheme={setTheme} />}>
            {staffRoutes}
          </Route>
        ) : role === 'parent' ? (
          <Route element={<Layout role="parent" theme={theme} setTheme={setTheme} />}>
            <Route path="/"           element={<Navigate to="/home" />}    />
            <Route path="/home"       element={<ParentHome />}             />
            <Route path="/grades"     element={<ParentGrades />}           />
            <Route path="/attendance" element={<ParentAttendance />}       />
            <Route path="/homework"   element={<ParentHomework />}         />
            <Route path="/reports"    element={<ParentReports />}          />
            <Route path="/videos"     element={<Videos role="parent" />} />
            <Route path="/settings"   element={<Settings theme={theme} setTheme={setTheme} />} />
          </Route>
        ) : role === 'student' ? (
          <Route element={<Layout role="student" theme={theme} setTheme={setTheme} />}>
            <Route path="/"           element={<Navigate to="/home" />}    />
            <Route path="/home"       element={<StudentHome />}            />
            <Route path="/grades"     element={<StudentGrades />}          />
            <Route path="/attendance" element={<StudentAttendance />}      />
            <Route path="/homework"   element={<StudentHomework />}        />
            <Route path="/reports"    element={<StudentReports />}         />
            <Route path="/videos"     element={<Videos role="student" />} />
            <Route path="/settings"   element={<Settings theme={theme} setTheme={setTheme} />} />
          </Route>
        ) : (
          <Route path="*" element={<Login />} />
        )}
      </Routes>
    </BrowserRouter>
  )
}